import type { SetupTourDefinition } from '../core/types';
import { ROUTES } from '@/constants';

// The key stays age_limits_setup: the backend's quick-start catalogue fixes it.
export const AGE_LIMITS_SETUP_TOUR_TARGETS = {
  grid: 'driver-age-grid',
  panel: 'driver-age-panel',
  saveButton: 'driver-age-save-button',
  saved: 'driver-age-saved',
} as const;

export const ageLimitsSetupTour: SetupTourDefinition = {
  id: 'age_limits_setup',
  label: 'Driver age',
  onboardingKey: 'age_limits_setup',
  steps: [
    {
      id: 'open-driver-age-cell',
      route: ROUTES.DRIVER_AGE,
      target: AGE_LIMITS_SETUP_TOUR_TARGETS.grid,
      content: 'Click a cell to set the age brackets of that vehicle group in that season.',
      advanceOnTargetClick: true,
    },
    {
      id: 'configure-driver-age',
      route: ROUTES.DRIVER_AGE,
      target: AGE_LIMITS_SETUP_TOUR_TARGETS.panel,
      content:
        'Add each age bracket with a charge per day, a charge once, or both. Brackets cannot overlap.',
      // A native Save click must reach the panel, so its own refusal message shows and a
      // corrected retry saves: no directNextTargets, no guardTarget. The tour completes when
      // the saved marker flips, and a refused save leaves it false on this step.
      advanceOnReady: AGE_LIMITS_SETUP_TOUR_TARGETS.saved,
      next: {
        label: 'Save',
        action: { type: 'click', target: AGE_LIMITS_SETUP_TOUR_TARGETS.saveButton },
        staysOnStep: true,
        completesTour: true,
      },
    },
  ],
};
